import { SelectBox } from "devextreme-react/select-box";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../contexts/auth";
import { RoleEnum } from "../../../types";
import { useViewSwitchContext } from "../contexts/ViewSwitchContext";

export const ViewSwitch = () => {
  const { t } = useTranslation();
  const { view, setViewState } = useViewSwitchContext();
  const authContext = useAuth();

  const views = useMemo(() => {
    const isMyViewAvailable = authContext.user!.roles!.some((role) =>
      [
        RoleEnum.Pracownik.toString(),
        RoleEnum.Majster.toString(),
        RoleEnum.Kierownik.toString(),
        RoleEnum.Manager.toString(),
      ].includes(role),
    );

    const isEmployeesViewAvailable =
      authContext.user!.roles!.some((role) =>
        [
          RoleEnum.Majster.toString(),
          RoleEnum.Kierownik.toString(),
          RoleEnum.Manager.toString(),
          RoleEnum.KadrySpolki.toString(),
          RoleEnum.AdministratorSpolki.toString(),
          RoleEnum.AdministratorGlowny.toString(),
        ].includes(role),
      ) || authContext.user!.isTimeManager;

    return [
      ...(isMyViewAvailable
        ? [{ id: "my", text: t("presence.views.my") }]
        : []),
      ...(isEmployeesViewAvailable
        ? [
            {
              id: "employees",
              text: t("presence.views.employees"),
            },
          ]
        : []),
    ];
  }, [authContext.user, t]);

  if (views.length === 1) {
    return null;
  }

  return (
    <SelectBox
      width={225}
      items={views}
      displayExpr="text"
      valueExpr="id"
      labelMode="static"
      label={t("view")}
      value={view}
      onValueChange={setViewState}
    />
  );
};
